module.exports = __webpack_public_path__ + "img/superiority2.e570278.png";